import { atom, useAtom, useSetAtom } from "jotai";

export const defaultLockValues = {
  show: false,
  active: false,
};
export const lockAtom = atom(defaultLockValues);
const useLock = () => {
  const atom = useAtom(lockAtom);
  return atom;
};

export const useSetLock = () => useSetAtom(lockAtom);

export default useLock;
